<div class="container">
  <div class="option-wrapper" [ngClass]="{'show-options':showOptions}" (click)="toggleOptions($event)">
    <div class="option-container">
      <bdr-checkbox size="small" *ngFor="let optionValue of optionValues" [(model)]="valueMap[optionValue.value]"
        [caption]="optionValue.name" (modelChange)="valueMap[optionValue.value] = $event; changeValue()"></bdr-checkbox>
    </div>
    <bdr-icon class="icon-show" *ngIf="!showOptions" icon="ico-select_down"></bdr-icon>
    <bdr-icon class="icon-show" *ngIf="showOptions" icon="ico-select_up"></bdr-icon>
  </div>
</div>